import dayjs, { type ConfigType } from 'dayjs'
import relativeTime from 'dayjs/plugin/relativeTime'
import 'dayjs/locale/zh-cn' // 导入中文语言包

dayjs.extend(relativeTime)
dayjs.locale('zh-cn') // 设置默认语言为中文

export const klDate = {
	/**
	 * 日期格式化
	 * */
	format(format: string = 'YYYY-MM-DD HH:mm:ss', date: ConfigType): string {
		return dayjs(date).format(format)
	},

	/**
	 * 格式化时间戳为日期时间字符串
	 * @param timestamp 时间戳 (秒或毫秒)
	 * @param format 格式字符串，默认为 'YYYY-MM-DD HH:mm:ss'
	 * @returns 格式化后的日期时间字符串或 '--'
	 */
	formatTimestamp(
		timestamp: number | string | null | undefined,
		format: string = 'YYYY-MM-DD HH:mm:ss',
	): string {
		if (!timestamp) {
			return '--'
		}
		// 检查是否为秒级时间戳，如果是则转换为毫秒
		const ts = typeof timestamp === 'string' ? parseInt(timestamp) : timestamp
		const finalTs = ts.toString().length === 10 ? ts * 1000 : ts

		const date = dayjs(finalTs)
		return date.isValid() ? date.format(format) : '--'
	},

	/**
	 * 格式化时间戳为日期字符串 (YYYY-MM-DD)
	 * @param timestamp 时间戳
	 * @returns 格式化后的日期字符串或 '--'
	 */
	formatDate(timestamp: number | string | null | undefined): string {
		return this.formatTimestamp(timestamp, 'YYYY-MM-DD')
	},

	/**
	 * 格式化时间戳为时间字符串 (HH:mm:ss)
	 * @param timestamp 时间戳
	 * @returns 格式化后的时间字符串或 '--'
	 */
	formatTime(timestamp: number | string | null | undefined): string {
		return this.formatTimestamp(timestamp, 'HH:mm:ss')
	},

	/**
	 * 格式化时间戳为相对时间，如"3分钟前"
	 * @param timestamp 时间戳 (秒或毫秒)
	 * @returns 相对时间字符串或 '--'
	 */
	formatRelativeTime(timestamp: number | string | null | undefined): string {
		if (!timestamp) {
			return '--'
		}
		const ts = typeof timestamp === 'string' ? parseInt(timestamp) : timestamp
		const finalTs = ts.toString().length === 10 ? ts * 1000 : ts

		const date = dayjs(finalTs)
		return date.isValid() ? date.fromNow() : '--'
	},
}
